import { render } from "./ComponentInputText.vue?vue&type=template&id=3bef36f1&scoped=true"
import script from "./ComponentInputText.vue?vue&type=script&lang=js"
export * from "./ComponentInputText.vue?vue&type=script&lang=js"

import "./ComponentInputText.vue?vue&type=style&index=0&id=3bef36f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bef36f1"]])

export default __exports__